import { HighlightablePlainText } from './HighlightablePlainText';
import { HighlightableRichText } from './HighlightableRichText';
import { HighlightableTextProps } from './shared';

/**
 * A smart text highlighting component that automatically chooses between
 * plain text and rich text highlighting based on the provided props.
 *
 * @param props - HighlightableTextProps
 * @returns ReactElement - Either HighlightablePlainText or HighlightableRichText
 */
export function HighlightableText(props: HighlightableTextProps) {
  // If richTextContent is provided, use the rich text component
  if (props.richTextContent) {
    return <HighlightableRichText {...props} />;
  }

  // Otherwise, use the plain text component
  return <HighlightablePlainText {...props} />;
}

// Re-export types for convenience
export type { HighlightableTextProps, BaseHighlightableTextProps } from './shared';
